import { jsx as K, jsxs as Oe } from "react/jsx-runtime";
import I, { useState as yr, useRef as Le, useEffect as hr } from "react";
function br(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ze = { exports: {} }, M = Ze.exports = {}, Q, Z;
function Fe() {
  throw new Error("setTimeout has not been defined");
}
function Se() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Q = setTimeout : Q = Fe;
  } catch {
    Q = Fe;
  }
  try {
    typeof clearTimeout == "function" ? Z = clearTimeout : Z = Se;
  } catch {
    Z = Se;
  }
})();
function er(e) {
  if (Q === setTimeout)
    return setTimeout(e, 0);
  if ((Q === Fe || !Q) && setTimeout)
    return Q = setTimeout, setTimeout(e, 0);
  try {
    return Q(e, 0);
  } catch {
    try {
      return Q.call(null, e, 0);
    } catch {
      return Q.call(this, e, 0);
    }
  }
}
function gr(e) {
  if (Z === clearTimeout)
    return clearTimeout(e);
  if ((Z === Se || !Z) && clearTimeout)
    return Z = clearTimeout, clearTimeout(e);
  try {
    return Z(e);
  } catch {
    try {
      return Z.call(null, e);
    } catch {
      return Z.call(this, e);
    }
  }
}
var re = [], fe = !1, ce, Ee = -1;
function Er() {
  !fe || !ce || (fe = !1, ce.length ? re = ce.concat(re) : Ee = -1, re.length && rr());
}
function rr() {
  if (!fe) {
    var e = er(Er);
    fe = !0;
    for (var r = re.length; r; ) {
      for (ce = re, re = []; ++Ee < r; )
        ce && ce[Ee].run();
      Ee = -1, r = re.length;
    }
    ce = null, fe = !1, gr(e);
  }
}
M.nextTick = function(e) {
  var r = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      r[t - 1] = arguments[t];
  re.push(new tr(e, r)), re.length === 1 && !fe && er(rr);
};
function tr(e, r) {
  this.fun = e, this.array = r;
}
tr.prototype.run = function() {
  this.fun.apply(null, this.array);
};
M.title = "browser";
M.browser = !0;
M.env = {};
M.argv = [];
M.version = "";
M.versions = {};
function te() {
}
M.on = te;
M.addListener = te;
M.once = te;
M.off = te;
M.removeListener = te;
M.removeAllListeners = te;
M.emit = te;
M.prependListener = te;
M.prependOnceListener = te;
M.listeners = function(e) {
  return [];
};
M.binding = function(e) {
  throw new Error("process.binding is not supported");
};
M.cwd = function() {
  return "/";
};
M.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
M.umask = function() {
  return 0;
};
var Cr = Ze.exports;
const G = /* @__PURE__ */ br(Cr);
function mr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ae = { exports: {} }, he = { exports: {} }, O = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function Pr() {
  if (We) return O;
  We = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, p = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, j = e ? Symbol.for("react.fundamental") : 60117, B = e ? Symbol.for("react.responder") : 60118, W = e ? Symbol.for("react.scope") : 60119;
  function h(c) {
    if (typeof c == "object" && c !== null) {
      var Y = c.$$typeof;
      switch (Y) {
        case r:
          switch (c = c.type, c) {
            case s:
            case d:
            case o:
            case i:
            case n:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case v:
                case k:
                case S:
                case p:
                  return c;
                default:
                  return Y;
              }
          }
        case t:
          return Y;
      }
    }
  }
  function R(c) {
    return h(c) === d;
  }
  return O.AsyncMode = s, O.ConcurrentMode = d, O.ContextConsumer = l, O.ContextProvider = p, O.Element = r, O.ForwardRef = v, O.Fragment = o, O.Lazy = k, O.Memo = S, O.Portal = t, O.Profiler = i, O.StrictMode = n, O.Suspense = y, O.isAsyncMode = function(c) {
    return R(c) || h(c) === s;
  }, O.isConcurrentMode = R, O.isContextConsumer = function(c) {
    return h(c) === l;
  }, O.isContextProvider = function(c) {
    return h(c) === p;
  }, O.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, O.isForwardRef = function(c) {
    return h(c) === v;
  }, O.isFragment = function(c) {
    return h(c) === o;
  }, O.isLazy = function(c) {
    return h(c) === k;
  }, O.isMemo = function(c) {
    return h(c) === S;
  }, O.isPortal = function(c) {
    return h(c) === t;
  }, O.isProfiler = function(c) {
    return h(c) === i;
  }, O.isStrictMode = function(c) {
    return h(c) === n;
  }, O.isSuspense = function(c) {
    return h(c) === y;
  }, O.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === o || c === d || c === i || c === n || c === y || c === g || typeof c == "object" && c !== null && (c.$$typeof === k || c.$$typeof === S || c.$$typeof === p || c.$$typeof === l || c.$$typeof === v || c.$$typeof === j || c.$$typeof === B || c.$$typeof === W || c.$$typeof === C);
  }, O.typeOf = h, O;
}
var F = {}, Me;
function xr() {
  return Me || (Me = 1, G.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, p = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, j = e ? Symbol.for("react.fundamental") : 60117, B = e ? Symbol.for("react.responder") : 60118, W = e ? Symbol.for("react.scope") : 60119;
    function h(f) {
      return typeof f == "string" || typeof f == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      f === o || f === d || f === i || f === n || f === y || f === g || typeof f == "object" && f !== null && (f.$$typeof === k || f.$$typeof === S || f.$$typeof === p || f.$$typeof === l || f.$$typeof === v || f.$$typeof === j || f.$$typeof === B || f.$$typeof === W || f.$$typeof === C);
    }
    function R(f) {
      if (typeof f == "object" && f !== null) {
        var H = f.$$typeof;
        switch (H) {
          case r:
            var ye = f.type;
            switch (ye) {
              case s:
              case d:
              case o:
              case i:
              case n:
              case y:
                return ye;
              default:
                var Be = ye && ye.$$typeof;
                switch (Be) {
                  case l:
                  case v:
                  case k:
                  case S:
                  case p:
                    return Be;
                  default:
                    return H;
                }
            }
          case t:
            return H;
        }
      }
    }
    var c = s, Y = d, ne = l, oe = p, ae = r, X = v, q = o, ie = k, pe = S, ee = t, D = i, V = n, U = y, se = !1;
    function ue(f) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), a(f) || R(f) === s;
    }
    function a(f) {
      return R(f) === d;
    }
    function u(f) {
      return R(f) === l;
    }
    function x(f) {
      return R(f) === p;
    }
    function m(f) {
      return typeof f == "object" && f !== null && f.$$typeof === r;
    }
    function b(f) {
      return R(f) === v;
    }
    function T(f) {
      return R(f) === o;
    }
    function E(f) {
      return R(f) === k;
    }
    function P(f) {
      return R(f) === S;
    }
    function _(f) {
      return R(f) === t;
    }
    function A(f) {
      return R(f) === i;
    }
    function w(f) {
      return R(f) === n;
    }
    function N(f) {
      return R(f) === y;
    }
    F.AsyncMode = c, F.ConcurrentMode = Y, F.ContextConsumer = ne, F.ContextProvider = oe, F.Element = ae, F.ForwardRef = X, F.Fragment = q, F.Lazy = ie, F.Memo = pe, F.Portal = ee, F.Profiler = D, F.StrictMode = V, F.Suspense = U, F.isAsyncMode = ue, F.isConcurrentMode = a, F.isContextConsumer = u, F.isContextProvider = x, F.isElement = m, F.isForwardRef = b, F.isFragment = T, F.isLazy = E, F.isMemo = P, F.isPortal = _, F.isProfiler = A, F.isStrictMode = w, F.isSuspense = N, F.isValidElementType = h, F.typeOf = R;
  }()), F;
}
var $e;
function nr() {
  return $e || ($e = 1, G.env.NODE_ENV === "production" ? he.exports = Pr() : he.exports = xr()), he.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Pe, ze;
function Tr() {
  if (ze) return Pe;
  ze = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var p = {}, l = 0; l < 10; l++)
        p["_" + String.fromCharCode(l)] = l;
      var s = Object.getOwnPropertyNames(p).map(function(v) {
        return p[v];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        d[v] = v;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Pe = n() ? Object.assign : function(i, p) {
    for (var l, s = o(i), d, v = 1; v < arguments.length; v++) {
      l = Object(arguments[v]);
      for (var y in l)
        r.call(l, y) && (s[y] = l[y]);
      if (e) {
        d = e(l);
        for (var g = 0; g < d.length; g++)
          t.call(l, d[g]) && (s[d[g]] = l[d[g]]);
      }
    }
    return s;
  }, Pe;
}
var xe, qe;
function ke() {
  if (qe) return xe;
  qe = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return xe = e, xe;
}
var Te, De;
function or() {
  return De || (De = 1, Te = Function.call.bind(Object.prototype.hasOwnProperty)), Te;
}
var _e, Ue;
function _r() {
  if (Ue) return _e;
  Ue = 1;
  var e = function() {
  };
  if (G.env.NODE_ENV !== "production") {
    var r = ke(), t = {}, o = or();
    e = function(i) {
      var p = "Warning: " + i;
      typeof console < "u" && console.error(p);
      try {
        throw new Error(p);
      } catch {
      }
    };
  }
  function n(i, p, l, s, d) {
    if (G.env.NODE_ENV !== "production") {
      for (var v in i)
        if (o(i, v)) {
          var y;
          try {
            if (typeof i[v] != "function") {
              var g = Error(
                (s || "React class") + ": " + l + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            y = i[v](p, v, s, l, null, r);
          } catch (k) {
            y = k;
          }
          if (y && !(y instanceof Error) && e(
            (s || "React class") + ": type specification of " + l + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), y instanceof Error && !(y.message in t)) {
            t[y.message] = !0;
            var S = d ? d() : "";
            e(
              "Failed " + l + " type: " + y.message + (S ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    G.env.NODE_ENV !== "production" && (t = {});
  }, _e = n, _e;
}
var we, Ye;
function wr() {
  if (Ye) return we;
  Ye = 1;
  var e = nr(), r = Tr(), t = ke(), o = or(), n = _r(), i = function() {
  };
  G.env.NODE_ENV !== "production" && (i = function(l) {
    var s = "Warning: " + l;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function p() {
    return null;
  }
  return we = function(l, s) {
    var d = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function y(a) {
      var u = a && (d && a[d] || a[v]);
      if (typeof u == "function")
        return u;
    }
    var g = "<<anonymous>>", S = {
      array: B("array"),
      bigint: B("bigint"),
      bool: B("boolean"),
      func: B("function"),
      number: B("number"),
      object: B("object"),
      string: B("string"),
      symbol: B("symbol"),
      any: W(),
      arrayOf: h,
      element: R(),
      elementType: c(),
      instanceOf: Y,
      node: X(),
      objectOf: oe,
      oneOf: ne,
      oneOfType: ae,
      shape: ie,
      exact: pe
    };
    function k(a, u) {
      return a === u ? a !== 0 || 1 / a === 1 / u : a !== a && u !== u;
    }
    function C(a, u) {
      this.message = a, this.data = u && typeof u == "object" ? u : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function j(a) {
      if (G.env.NODE_ENV !== "production")
        var u = {}, x = 0;
      function m(T, E, P, _, A, w, N) {
        if (_ = _ || g, w = w || P, N !== t) {
          if (s) {
            var f = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw f.name = "Invariant Violation", f;
          } else if (G.env.NODE_ENV !== "production" && typeof console < "u") {
            var H = _ + ":" + P;
            !u[H] && // Avoid spamming the console because they are often not actionable except for lib authors
            x < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + w + "` prop on `" + _ + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), u[H] = !0, x++);
          }
        }
        return E[P] == null ? T ? E[P] === null ? new C("The " + A + " `" + w + "` is marked as required " + ("in `" + _ + "`, but its value is `null`.")) : new C("The " + A + " `" + w + "` is marked as required in " + ("`" + _ + "`, but its value is `undefined`.")) : null : a(E, P, _, A, w);
      }
      var b = m.bind(null, !1);
      return b.isRequired = m.bind(null, !0), b;
    }
    function B(a) {
      function u(x, m, b, T, E, P) {
        var _ = x[m], A = V(_);
        if (A !== a) {
          var w = U(_);
          return new C(
            "Invalid " + T + " `" + E + "` of type " + ("`" + w + "` supplied to `" + b + "`, expected ") + ("`" + a + "`."),
            { expectedType: a }
          );
        }
        return null;
      }
      return j(u);
    }
    function W() {
      return j(p);
    }
    function h(a) {
      function u(x, m, b, T, E) {
        if (typeof a != "function")
          return new C("Property `" + E + "` of component `" + b + "` has invalid PropType notation inside arrayOf.");
        var P = x[m];
        if (!Array.isArray(P)) {
          var _ = V(P);
          return new C("Invalid " + T + " `" + E + "` of type " + ("`" + _ + "` supplied to `" + b + "`, expected an array."));
        }
        for (var A = 0; A < P.length; A++) {
          var w = a(P, A, b, T, E + "[" + A + "]", t);
          if (w instanceof Error)
            return w;
        }
        return null;
      }
      return j(u);
    }
    function R() {
      function a(u, x, m, b, T) {
        var E = u[x];
        if (!l(E)) {
          var P = V(E);
          return new C("Invalid " + b + " `" + T + "` of type " + ("`" + P + "` supplied to `" + m + "`, expected a single ReactElement."));
        }
        return null;
      }
      return j(a);
    }
    function c() {
      function a(u, x, m, b, T) {
        var E = u[x];
        if (!e.isValidElementType(E)) {
          var P = V(E);
          return new C("Invalid " + b + " `" + T + "` of type " + ("`" + P + "` supplied to `" + m + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return j(a);
    }
    function Y(a) {
      function u(x, m, b, T, E) {
        if (!(x[m] instanceof a)) {
          var P = a.name || g, _ = ue(x[m]);
          return new C("Invalid " + T + " `" + E + "` of type " + ("`" + _ + "` supplied to `" + b + "`, expected ") + ("instance of `" + P + "`."));
        }
        return null;
      }
      return j(u);
    }
    function ne(a) {
      if (!Array.isArray(a))
        return G.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), p;
      function u(x, m, b, T, E) {
        for (var P = x[m], _ = 0; _ < a.length; _++)
          if (k(P, a[_]))
            return null;
        var A = JSON.stringify(a, function(N, f) {
          var H = U(f);
          return H === "symbol" ? String(f) : f;
        });
        return new C("Invalid " + T + " `" + E + "` of value `" + String(P) + "` " + ("supplied to `" + b + "`, expected one of " + A + "."));
      }
      return j(u);
    }
    function oe(a) {
      function u(x, m, b, T, E) {
        if (typeof a != "function")
          return new C("Property `" + E + "` of component `" + b + "` has invalid PropType notation inside objectOf.");
        var P = x[m], _ = V(P);
        if (_ !== "object")
          return new C("Invalid " + T + " `" + E + "` of type " + ("`" + _ + "` supplied to `" + b + "`, expected an object."));
        for (var A in P)
          if (o(P, A)) {
            var w = a(P, A, b, T, E + "." + A, t);
            if (w instanceof Error)
              return w;
          }
        return null;
      }
      return j(u);
    }
    function ae(a) {
      if (!Array.isArray(a))
        return G.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), p;
      for (var u = 0; u < a.length; u++) {
        var x = a[u];
        if (typeof x != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(x) + " at index " + u + "."
          ), p;
      }
      function m(b, T, E, P, _) {
        for (var A = [], w = 0; w < a.length; w++) {
          var N = a[w], f = N(b, T, E, P, _, t);
          if (f == null)
            return null;
          f.data && o(f.data, "expectedType") && A.push(f.data.expectedType);
        }
        var H = A.length > 0 ? ", expected one of type [" + A.join(", ") + "]" : "";
        return new C("Invalid " + P + " `" + _ + "` supplied to " + ("`" + E + "`" + H + "."));
      }
      return j(m);
    }
    function X() {
      function a(u, x, m, b, T) {
        return ee(u[x]) ? null : new C("Invalid " + b + " `" + T + "` supplied to " + ("`" + m + "`, expected a ReactNode."));
      }
      return j(a);
    }
    function q(a, u, x, m, b) {
      return new C(
        (a || "React class") + ": " + u + " type `" + x + "." + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + b + "`."
      );
    }
    function ie(a) {
      function u(x, m, b, T, E) {
        var P = x[m], _ = V(P);
        if (_ !== "object")
          return new C("Invalid " + T + " `" + E + "` of type `" + _ + "` " + ("supplied to `" + b + "`, expected `object`."));
        for (var A in a) {
          var w = a[A];
          if (typeof w != "function")
            return q(b, T, E, A, U(w));
          var N = w(P, A, b, T, E + "." + A, t);
          if (N)
            return N;
        }
        return null;
      }
      return j(u);
    }
    function pe(a) {
      function u(x, m, b, T, E) {
        var P = x[m], _ = V(P);
        if (_ !== "object")
          return new C("Invalid " + T + " `" + E + "` of type `" + _ + "` " + ("supplied to `" + b + "`, expected `object`."));
        var A = r({}, x[m], a);
        for (var w in A) {
          var N = a[w];
          if (o(a, w) && typeof N != "function")
            return q(b, T, E, w, U(N));
          if (!N)
            return new C(
              "Invalid " + T + " `" + E + "` key `" + w + "` supplied to `" + b + "`.\nBad object: " + JSON.stringify(x[m], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(a), null, "  ")
            );
          var f = N(P, w, b, T, E + "." + w, t);
          if (f)
            return f;
        }
        return null;
      }
      return j(u);
    }
    function ee(a) {
      switch (typeof a) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !a;
        case "object":
          if (Array.isArray(a))
            return a.every(ee);
          if (a === null || l(a))
            return !0;
          var u = y(a);
          if (u) {
            var x = u.call(a), m;
            if (u !== a.entries) {
              for (; !(m = x.next()).done; )
                if (!ee(m.value))
                  return !1;
            } else
              for (; !(m = x.next()).done; ) {
                var b = m.value;
                if (b && !ee(b[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(a, u) {
      return a === "symbol" ? !0 : u ? u["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && u instanceof Symbol : !1;
    }
    function V(a) {
      var u = typeof a;
      return Array.isArray(a) ? "array" : a instanceof RegExp ? "object" : D(u, a) ? "symbol" : u;
    }
    function U(a) {
      if (typeof a > "u" || a === null)
        return "" + a;
      var u = V(a);
      if (u === "object") {
        if (a instanceof Date)
          return "date";
        if (a instanceof RegExp)
          return "regexp";
      }
      return u;
    }
    function se(a) {
      var u = U(a);
      switch (u) {
        case "array":
        case "object":
          return "an " + u;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + u;
        default:
          return u;
      }
    }
    function ue(a) {
      return !a.constructor || !a.constructor.name ? g : a.constructor.name;
    }
    return S.checkPropTypes = n, S.resetWarningCache = n.resetWarningCache, S.PropTypes = S, S;
  }, we;
}
var Re, Ne;
function Rr() {
  if (Ne) return Re;
  Ne = 1;
  var e = ke();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Re = function() {
    function o(p, l, s, d, v, y) {
      if (y !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    o.isRequired = o;
    function n() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: n,
      element: o,
      elementType: o,
      instanceOf: n,
      node: o,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, Re;
}
if (G.env.NODE_ENV !== "production") {
  var Or = nr(), Fr = !0;
  Ae.exports = wr()(Or.isElement, Fr);
} else
  Ae.exports = Rr()();
var Sr = Ae.exports;
const L = /* @__PURE__ */ mr(Sr);
function Je(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function Ve(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Je(Object(t), !0).forEach(function(o) {
      ar(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Je(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
function Ce(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ce = function(r) {
    return typeof r;
  } : Ce = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ce(e);
}
function ar(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ir(e, r) {
  return Ar(e) || jr(e, r) || Ir(e, r) || kr();
}
function Ar(e) {
  if (Array.isArray(e)) return e;
}
function jr(e, r) {
  var t = e && (typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"]);
  if (t != null) {
    var o = [], n = !0, i = !1, p, l;
    try {
      for (t = t.call(e); !(n = (p = t.next()).done) && (o.push(p.value), !(r && o.length === r)); n = !0)
        ;
    } catch (s) {
      i = !0, l = s;
    } finally {
      try {
        !n && t.return != null && t.return();
      } finally {
        if (i) throw l;
      }
    }
    return o;
  }
}
function Ir(e, r) {
  if (e) {
    if (typeof e == "string") return Ke(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ke(e, r);
  }
}
function Ke(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, o = new Array(r); t < r; t++) o[t] = e[t];
  return o;
}
function kr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var J = function(r, t, o) {
  var n = !!o, i = I.useRef(o);
  I.useEffect(function() {
    i.current = o;
  }, [o]), I.useEffect(function() {
    if (!n || !r)
      return function() {
      };
    var p = function() {
      i.current && i.current.apply(i, arguments);
    };
    return r.on(t, p), function() {
      r.off(t, p);
    };
  }, [n, t, r, i]);
}, je = function(r) {
  var t = I.useRef(r);
  return I.useEffect(function() {
    t.current = r;
  }, [r]), t.current;
}, le = function(r) {
  return r !== null && Ce(r) === "object";
}, Br = function(r) {
  return le(r) && typeof r.then == "function";
}, Lr = function(r) {
  return le(r) && typeof r.elements == "function" && typeof r.createToken == "function" && typeof r.createPaymentMethod == "function" && typeof r.confirmCardPayment == "function";
}, Ge = "[object Object]", Wr = function e(r, t) {
  if (!le(r) || !le(t))
    return r === t;
  var o = Array.isArray(r), n = Array.isArray(t);
  if (o !== n) return !1;
  var i = Object.prototype.toString.call(r) === Ge, p = Object.prototype.toString.call(t) === Ge;
  if (i !== p) return !1;
  if (!i && !o) return r === t;
  var l = Object.keys(r), s = Object.keys(t);
  if (l.length !== s.length) return !1;
  for (var d = {}, v = 0; v < l.length; v += 1)
    d[l[v]] = !0;
  for (var y = 0; y < s.length; y += 1)
    d[s[y]] = !0;
  var g = Object.keys(d);
  if (g.length !== l.length)
    return !1;
  var S = r, k = t, C = function(B) {
    return e(S[B], k[B]);
  };
  return g.every(C);
}, sr = function(r, t, o) {
  return le(r) ? Object.keys(r).reduce(function(n, i) {
    var p = !le(t) || !Wr(r[i], t[i]);
    return o.includes(i) ? (p && console.warn("Unsupported prop change: options.".concat(i, " is not a mutable property.")), n) : p ? Ve(Ve({}, n || {}), {}, ar({}, i, r[i])) : n;
  }, null) : null;
}, ur = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", Xe = function(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ur;
  if (r === null || Lr(r))
    return r;
  throw new Error(t);
}, Mr = function(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ur;
  if (Br(r))
    return {
      tag: "async",
      stripePromise: Promise.resolve(r).then(function(n) {
        return Xe(n, t);
      })
    };
  var o = Xe(r, t);
  return o === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: o
  };
}, $r = function(r) {
  !r || !r._registerWrapper || !r.registerAppInfo || (r._registerWrapper({
    name: "react-stripe-js",
    version: "3.3.0"
  }), r.registerAppInfo({
    name: "react-stripe-js",
    version: "3.3.0",
    url: "https://stripe.com/docs/stripe-js/react"
  }));
}, me = /* @__PURE__ */ I.createContext(null);
me.displayName = "ElementsContext";
var cr = function(r, t) {
  if (!r)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(t, " in an <Elements> provider."));
  return r;
}, fr = function(r) {
  var t = r.stripe, o = r.options, n = r.children, i = I.useMemo(function() {
    return Mr(t);
  }, [t]), p = I.useState(function() {
    return {
      stripe: i.tag === "sync" ? i.stripe : null,
      elements: i.tag === "sync" ? i.stripe.elements(o) : null
    };
  }), l = ir(p, 2), s = l[0], d = l[1];
  I.useEffect(function() {
    var g = !0, S = function(C) {
      d(function(j) {
        return j.stripe ? j : {
          stripe: C,
          elements: C.elements(o)
        };
      });
    };
    return i.tag === "async" && !s.stripe ? i.stripePromise.then(function(k) {
      k && g && S(k);
    }) : i.tag === "sync" && !s.stripe && S(i.stripe), function() {
      g = !1;
    };
  }, [i, s, o]);
  var v = je(t);
  I.useEffect(function() {
    v !== null && v !== t && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [v, t]);
  var y = je(o);
  return I.useEffect(function() {
    if (s.elements) {
      var g = sr(o, y, ["clientSecret", "fonts"]);
      g && s.elements.update(g);
    }
  }, [o, y, s.elements]), I.useEffect(function() {
    $r(s.stripe);
  }, [s.stripe]), /* @__PURE__ */ I.createElement(me.Provider, {
    value: s
  }, n);
};
fr.propTypes = {
  stripe: L.any,
  options: L.object
};
var zr = function(r) {
  var t = I.useContext(me);
  return cr(t, r);
}, qr = function() {
  var r = zr("calls useElements()"), t = r.elements;
  return t;
};
L.func.isRequired;
var lr = /* @__PURE__ */ I.createContext(null);
lr.displayName = "CheckoutSdkContext";
var Dr = function(r, t) {
  if (!r)
    throw new Error("Could not find CheckoutProvider context; You need to wrap the part of your app that ".concat(t, " in an <CheckoutProvider> provider."));
  return r;
}, Ur = /* @__PURE__ */ I.createContext(null);
Ur.displayName = "CheckoutContext";
L.any, L.shape({
  clientSecret: L.string.isRequired,
  elementsOptions: L.object
}).isRequired;
var Ie = function(r) {
  var t = I.useContext(lr), o = I.useContext(me);
  if (t && o)
    throw new Error("You cannot wrap the part of your app that ".concat(r, " in both <CheckoutProvider> and <Elements> providers."));
  return t ? Dr(t, r) : cr(o, r);
}, Yr = function(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}, $ = function(r, t) {
  var o = "".concat(Yr(r), "Element"), n = function(s) {
    var d = s.id, v = s.className, y = s.options, g = y === void 0 ? {} : y, S = s.onBlur, k = s.onFocus, C = s.onReady, j = s.onChange, B = s.onEscape, W = s.onClick, h = s.onLoadError, R = s.onLoaderStart, c = s.onNetworksChange, Y = s.onConfirm, ne = s.onCancel, oe = s.onShippingAddressChange, ae = s.onShippingRateChange, X = Ie("mounts <".concat(o, ">")), q = "elements" in X ? X.elements : null, ie = "checkoutSdk" in X ? X.checkoutSdk : null, pe = I.useState(null), ee = ir(pe, 2), D = ee[0], V = ee[1], U = I.useRef(null), se = I.useRef(null);
    J(D, "blur", S), J(D, "focus", k), J(D, "escape", B), J(D, "click", W), J(D, "loaderror", h), J(D, "loaderstart", R), J(D, "networkschange", c), J(D, "confirm", Y), J(D, "cancel", ne), J(D, "shippingaddresschange", oe), J(D, "shippingratechange", ae), J(D, "change", j);
    var ue;
    C && (r === "expressCheckout" ? ue = C : ue = function() {
      C(D);
    }), J(D, "ready", ue), I.useLayoutEffect(function() {
      if (U.current === null && se.current !== null && (q || ie)) {
        var u = null;
        ie ? u = ie.createElement(r, g) : q && (u = q.create(r, g)), U.current = u, V(u), u && u.mount(se.current);
      }
    }, [q, ie, g]);
    var a = je(g);
    return I.useEffect(function() {
      if (U.current) {
        var u = sr(g, a, ["paymentRequest"]);
        u && "update" in U.current && U.current.update(u);
      }
    }, [g, a]), I.useLayoutEffect(function() {
      return function() {
        if (U.current && typeof U.current.destroy == "function")
          try {
            U.current.destroy(), U.current = null;
          } catch {
          }
      };
    }, []), /* @__PURE__ */ I.createElement("div", {
      id: d,
      className: v,
      ref: se
    });
  }, i = function(s) {
    Ie("mounts <".concat(o, ">"));
    var d = s.id, v = s.className;
    return /* @__PURE__ */ I.createElement("div", {
      id: d,
      className: v
    });
  }, p = t ? i : n;
  return p.propTypes = {
    id: L.string,
    className: L.string,
    onChange: L.func,
    onBlur: L.func,
    onFocus: L.func,
    onReady: L.func,
    onEscape: L.func,
    onClick: L.func,
    onLoadError: L.func,
    onLoaderStart: L.func,
    onNetworksChange: L.func,
    onConfirm: L.func,
    onCancel: L.func,
    onShippingAddressChange: L.func,
    onShippingRateChange: L.func,
    options: L.object
  }, p.displayName = o, p.__elementType = r, p;
}, z = typeof window > "u", Nr = /* @__PURE__ */ I.createContext(null);
Nr.displayName = "EmbeddedCheckoutProviderContext";
var Jr = function() {
  var r = Ie("calls useStripe()"), t = r.stripe;
  return t;
};
$("auBankAccount", z);
$("card", z);
$("cardNumber", z);
$("cardExpiry", z);
$("cardCvc", z);
$("fpxBank", z);
$("iban", z);
$("idealBank", z);
$("p24Bank", z);
$("epsBank", z);
var Vr = $("payment", z);
$("expressCheckout", z);
$("currencySelector", z);
$("paymentRequestButton", z);
$("linkAuthentication", z);
$("address", z);
$("shippingAddress", z);
$("paymentMethodMessaging", z);
$("affirmMessage", z);
$("afterpayClearpayMessage", z);
var Kr = "v3", Gr = function(r) {
  return r === 3 ? "v3" : r;
}, pr = "https://js.stripe.com", Xr = "".concat(pr, "/v3"), Hr = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, Qr = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/, He = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", Zr = function(r) {
  return Hr.test(r) || Qr.test(r);
}, et = function() {
  for (var r = document.querySelectorAll('script[src^="'.concat(pr, '"]')), t = 0; t < r.length; t++) {
    var o = r[t];
    if (Zr(o.src))
      return o;
  }
  return null;
}, Qe = function(r) {
  var t = "", o = document.createElement("script");
  o.src = "".concat(Xr).concat(t);
  var n = document.head || document.body;
  if (!n)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return n.appendChild(o), o;
}, rt = function(r, t) {
  !r || !r._registerWrapper || r._registerWrapper({
    name: "stripe-js",
    version: "5.10.0",
    startTime: t
  });
}, de = null, be = null, ge = null, tt = function(r) {
  return function(t) {
    r(new Error("Failed to load Stripe.js", {
      cause: t
    }));
  };
}, nt = function(r, t) {
  return function() {
    window.Stripe ? r(window.Stripe) : t(new Error("Stripe.js not available"));
  };
}, ot = function(r) {
  return de !== null ? de : (de = new Promise(function(t, o) {
    if (typeof window > "u" || typeof document > "u") {
      t(null);
      return;
    }
    if (window.Stripe && r && console.warn(He), window.Stripe) {
      t(window.Stripe);
      return;
    }
    try {
      var n = et();
      if (n && r)
        console.warn(He);
      else if (!n)
        n = Qe(r);
      else if (n && ge !== null && be !== null) {
        var i;
        n.removeEventListener("load", ge), n.removeEventListener("error", be), (i = n.parentNode) === null || i === void 0 || i.removeChild(n), n = Qe(r);
      }
      ge = nt(t, o), be = tt(o), n.addEventListener("load", ge), n.addEventListener("error", be);
    } catch (p) {
      o(p);
      return;
    }
  }), de.catch(function(t) {
    return de = null, Promise.reject(t);
  }));
}, at = function(r, t, o) {
  if (r === null)
    return null;
  var n = t[0], i = n.match(/^pk_test/), p = Gr(r.version), l = Kr;
  i && p !== l && console.warn("Stripe.js@".concat(p, " was loaded on the page, but @stripe/stripe-js@").concat("5.10.0", " expected Stripe.js@").concat(l, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
  var s = r.apply(void 0, t);
  return rt(s, o), s;
}, ve, dr = !1, vr = function() {
  return ve || (ve = ot(null).catch(function(r) {
    return ve = null, Promise.reject(r);
  }), ve);
};
Promise.resolve().then(function() {
  return vr();
}).catch(function(e) {
  dr || console.warn(e);
});
var it = function() {
  for (var r = arguments.length, t = new Array(r), o = 0; o < r; o++)
    t[o] = arguments[o];
  dr = !0;
  var n = Date.now();
  return vr().then(function(i) {
    return at(i, t, n);
  });
};
const st = ({
  onSuccess: e,
  onError: r,
  onCancel: t,
  return_url: o,
  commonStyle: n,
  isTestnet: i,
  intentType: p = "payment"
}) => {
  var j, B, W, h, R, c, Y, ne, oe, ae;
  const l = Jr(), s = qr(), [d, v] = yr(!1), y = async (X) => {
    if (X.preventDefault(), !(!l || !s)) {
      v(!0);
      try {
        let q;
        p === "setup" ? o ? q = await l.confirmSetup({
          elements: s,
          confirmParams: {
            return_url: o
          }
        }) : q = await l.confirmSetup({
          elements: s,
          redirect: "if_required"
        }) : o ? q = await l.confirmPayment({
          elements: s,
          confirmParams: {
            return_url: o
          }
        }) : q = await l.confirmPayment({
          elements: s,
          redirect: "if_required"
        }), q.error ? r == null || r(q.error) : e == null || e(q);
      } catch (q) {
        r == null || r(q);
      } finally {
        v(!1);
      }
    }
  }, g = {
    width: (n == null ? void 0 : n.containerWidth) || "100%",
    padding: (n == null ? void 0 : n.containerPadding) || "16px",
    backgroundColor: (n == null ? void 0 : n.colorContainer) || "#ffffff"
  }, S = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: (n == null ? void 0 : n.verticalSpacing) || "16px"
  }, k = {
    backgroundColor: ((j = n == null ? void 0 : n.submitButton) == null ? void 0 : j.backgroundColor) ?? "#4F46E5",
    color: ((B = n == null ? void 0 : n.submitButton) == null ? void 0 : B.textColor) ?? "#FFFFFF",
    fontSize: ((W = n == null ? void 0 : n.submitButton) == null ? void 0 : W.fontSize) ?? "14px",
    fontWeight: ((h = n == null ? void 0 : n.submitButton) == null ? void 0 : h.fontWeight) ?? 500,
    borderRadius: ((R = n == null ? void 0 : n.submitButton) == null ? void 0 : R.borderRadius) ?? "4px",
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
    opacity: d ? 0.5 : 1
  }, C = {
    backgroundColor: ((c = n == null ? void 0 : n.cancelButton) == null ? void 0 : c.backgroundColor) ?? "#F3F4F6",
    color: ((Y = n == null ? void 0 : n.cancelButton) == null ? void 0 : Y.textColor) ?? "#4B5563",
    fontSize: ((ne = n == null ? void 0 : n.cancelButton) == null ? void 0 : ne.fontSize) ?? "14px",
    fontWeight: ((oe = n == null ? void 0 : n.cancelButton) == null ? void 0 : oe.fontWeight) ?? 500,
    borderRadius: ((ae = n == null ? void 0 : n.cancelButton) == null ? void 0 : ae.borderRadius) ?? "4px",
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
    opacity: d ? 0.5 : 1
  };
  return /* @__PURE__ */ K("div", { style: g, children: /* @__PURE__ */ Oe("form", { onSubmit: y, children: [
    /* @__PURE__ */ K("div", { style: { marginBottom: (n == null ? void 0 : n.verticalSpacing) || "16px" }, children: /* @__PURE__ */ K(Vr, {}) }),
    /* @__PURE__ */ Oe("div", { style: S, children: [
      /* @__PURE__ */ K(
        "button",
        {
          type: "button",
          style: { ...C, cursor: d ? "not-allowed" : "pointer" },
          disabled: !l || d,
          onClick: t,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ K(
        "button",
        {
          type: "submit",
          style: { ...k, cursor: d ? "not-allowed" : "pointer" },
          disabled: !l || d,
          children: "Pay"
        }
      )
    ] })
  ] }) });
}, ut = (e) => ({
  theme: e.theme === "dark" ? "night" : "stripe",
  labels: "above",
  variables: {
    colorPrimary: e.colorPrimary,
    colorBackground: e.backgroundBody || "#ffffff",
    colorText: e.textColorParagraphs || "#1f1f1f",
    colorDanger: e.colorError,
    colorTextSecondary: e.textColorLabel,
    colorTextPlaceholder: e.placeholderColor,
    colorBackgroundText: e.textColorParagraphs || "#1f1f1f",
    borderRadius: e.borderRadius,
    fontFamily: e.fontFamily,
    fontSizeBase: e.fontSizeInput,
    fontWeightNormal: (e.fontWeightInput ?? 400).toString(),
    fontLineHeight: "1.5",
    focusOutline: "unset",
    focusBoxShadow: "none",
    colorSuccess: e.colorPrimary
  },
  rules: {
    ".Input": {
      border: `1px solid ${e.colorBorderInput ?? "#E5E7EB"}`,
      backgroundColor: e.colorInput ?? "#FFFFFF",
      color: e.textColorInput ?? "#1F2937"
    },
    ".Input:focus": {
      borderColor: e.colorPrimary ?? "#4F46E5"
    },
    ".Input:hover": {
      borderColor: e.colorBorderInput ?? "#E5E7EB"
    },
    ".Label": {
      color: e.textColorLabel ?? "#374151",
      fontSize: e.fontSizeLabel ?? "14px",
      fontWeight: (e.fontWeightLabel ?? 500).toString()
    },
    ".Tab": {
      backgroundColor: e.colorContainer ?? "#FFFFFF",
      borderColor: e.colorBorderInput ?? "#E5E7EB"
    },
    ".Tab--selected": {
      backgroundColor: e.colorPrimary ?? "#4F46E5",
      color: e.textColorPaymentButton ?? "#FFFFFF"
    }
  }
}), ct = ({
  clientSecret: e,
  commonStyle: r,
  onSuccess: t,
  onError: o,
  onCancel: n,
  return_url: i,
  isTestnet: p = !1,
  intentType: l = "setup"
}) => {
  const s = {
    clientSecret: e,
    appearance: ut(r)
  }, d = it(
    p ? "pk_test_51Odtp1JYpy7bkFtuwoI9JX5KEjpK66XQ1KO2nzmJ7d0aUM2g2alhMhsA6kELz2VvJO64RpgL82vqoBpAx4WsCjOc00mW98oWYW" : "pk_live_51Odtp1JYpy7bkFturM9ERf1yy1izpUMSIDK10yIigTwhHvzzJjDLzH8bJAk18IGTvnyRBfJg9o6BDGugmJs9ltYS00EL6TSa5T"
  );
  return /* @__PURE__ */ K(fr, { stripe: d, options: s, children: /* @__PURE__ */ K(
    st,
    {
      onSuccess: t,
      onError: o,
      onCancel: n,
      ...i ? { return_url: i } : {},
      commonStyle: r,
      isTestnet: p,
      intentType: l
    }
  ) });
}, ft = (e) => ({
  Font_Family: e.fontFamily ?? "system-ui, -apple-system, sans-serif",
  Font_Size_Label: (e.fontSizeLabel ?? "14px").replace("px", ""),
  Font_Size_Input_Fields: (e.fontSizeInput ?? "16px").replace("px", ""),
  Font_Size_Payment_Button: (e.fontSizePaymentButton ?? "16px").replace("px", ""),
  Font_Weight_Label: e.fontWeightLabel ?? 500,
  Font_Weight_Input_Fields: e.fontWeightInput ?? 400,
  Font_Weight_Payment_Button: e.fontWeightPaymentButton ?? 600,
  Color_Container: e.colorContainer ?? "#FFFFFF",
  Color_Border_Input_Fields: e.colorBorderInput ?? "#E5E7EB",
  Color_Border_Payment_Button: e.colorBorderPaymentButton ?? "transparent",
  Radius_Border: (e.borderRadius ?? "8px").replace("px", ""),
  Color_Disabled: e.colorDisabled ?? "#9CA3AF",
  Color_Error: e.colorError ?? "#EF4444",
  Color_Primary: e.colorPrimary ?? "#4F46E5",
  Color_Input_Fields: e.colorInput ?? "#FFFFFF",
  Text_Color_For_Label: e.textColorLabel ?? "#374151",
  Text_Color_For_Payment_Button: e.textColorPaymentButton ?? "#FFFFFF",
  Text_Color_For_Input_Fields: e.textColorInput ?? "#1F2937",
  Color_For_Text_Placeholder: e.placeholderColor ?? "#9CA3AF",
  Width_of_Container: e.containerWidth ?? "100%",
  Vertical_Padding: (e.verticalPadding ?? "12px").replace("px", ""),
  Vertical_Spacing_between_components: (e.verticalSpacing ?? "16px").replace("px", ""),
  Container_Padding: (e.containerPadding ?? "16px").replace("px", "")
}), lt = ({
  clientSecret: e,
  onSuccess: r,
  onError: t,
  return_url: o,
  commonStyle: n,
  isTestnet: i = !1
}) => {
  const p = Le(null), l = "paymob-elements", s = Le(!1), d = i ? "are_pk_test_87EatMLhbhUCdDjBeSLuGpm5uIyuEmnB" : "are_pk_live_WkbOfpeYn23KggFR6gIaXAbmjZf0QjKP", v = ["card", "google-pay", "apple-pay"], y = !1, g = !1, S = !1;
  return hr(() => {
    const k = (W) => {
      document.querySelector(`link[href="${W}"]`) || fetch(W).then((h) => h.text()).then((h) => {
        var Y;
        const R = document.createElement("style"), c = h.replace(
          /([^\r\n,{}]+)(,(?=[^}]*{)|\s*{)/g,
          ".paymob-payment-container $1$2"
        );
        R.textContent = c, (Y = p.current) == null || Y.appendChild(R);
      }).catch((h) => console.error("Error loading stylesheet:", h));
    }, C = (W) => new Promise((h) => {
      if (document.querySelector(`script[src="${W}"]`))
        h();
      else {
        const R = document.createElement("script");
        R.src = W, R.type = "module", R.onload = () => h(), document.body.appendChild(R);
      }
    }), j = async () => {
      if (!s.current)
        if (k("https://cdn.jsdelivr.net/npm/paymob-pixel@latest/styles.css"), k("https://cdn.jsdelivr.net/npm/paymob-pixel@latest/main.css"), await C("https://cdn.jsdelivr.net/npm/paymob-pixel@latest/main.js"), await C("https://pay.google.com/gp/p/js/pay.js"), typeof window.Pixel > "u") {
          const W = setInterval(() => {
            typeof window.Pixel < "u" && (clearInterval(W), B());
          }, 100);
        } else
          B();
    }, B = () => {
      if (!e || !p.current || s.current) return;
      const W = {
        clientSecret: e,
        elementId: l,
        paymentMethods: v,
        disablePay: y,
        showSaveCard: g,
        forceSaveCard: S,
        publicKey: d,
        //   returnUrl: return_url,
        // Before payment completion function
        beforePaymentComplete: async (h) => (console.log("Before payment completion:", h), !0),
        // After payment completion function
        afterPaymentComplete: async (h) => {
          console.log("Payment completed:", h), r && r();
        },
        // Payment cancellation function
        onPaymentCancel: () => {
          console.log("Payment cancelled"), t && t(new Error("Payment was cancelled"));
        },
        // Card validation change function
        cardValidationChanged: (h) => {
          console.log("Card validation:", h);
        }
      };
      n && (W.customStyle = ft(n));
      try {
        new window.Pixel(W), s.current = !0;
      } catch (h) {
        console.error("Error initializing Paymob Pixel:", h), t && t(h instanceof Error ? h : new Error("Error initializing Paymob payment"));
      }
    };
    return j(), () => {
      s.current = !1;
    };
  }, [e, r, t, o, n]), /* @__PURE__ */ K("div", { className: "paymob-payment-container", ref: p, children: /* @__PURE__ */ K("div", { id: l, style: { width: "100%" } }) });
}, pt = "_error_13ocz_1", dt = {
  error: pt,
  "stripe-payment-container": "_stripe-payment-container_13ocz_19",
  "paymob-payment-container": "_paymob-payment-container_13ocz_21",
  "stripe-element-container": "_stripe-element-container_13ocz_35",
  "paymob-iframe-container": "_paymob-iframe-container_13ocz_37"
}, vt = {
  backgroundColor: "#4F46E5",
  textColor: "#FFFFFF",
  fontSize: "14px",
  fontWeight: 500,
  borderRadius: "4px"
}, yt = {
  fontFamily: "system-ui, -apple-system, sans-serif",
  fontSizeLabel: "14px",
  fontSizeInput: "16px",
  fontSizePaymentButton: "16px",
  fontWeightLabel: 500,
  fontWeightInput: 400,
  fontWeightPaymentButton: 600,
  colorContainer: "#FFFFFF",
  colorBorderInput: "#E5E7EB",
  colorBorderPaymentButton: "transparent",
  borderRadius: "8px",
  colorDisabled: "#9CA3AF",
  colorError: "#EF4444",
  colorPrimary: "#4F46E5",
  colorInput: "#FFFFFF",
  textColorLabel: "#374151",
  textColorPaymentButton: "#FFFFFF",
  textColorInput: "#1F2937",
  placeholderColor: "#9CA3AF",
  containerWidth: "100%",
  verticalPadding: "12px",
  verticalSpacing: "16px",
  containerPadding: "16px",
  backgroundBody: "#F9FAFB",
  textColorParagraphs: "#4B5563",
  submitButton: {
    ...vt
  },
  cancelButton: {
    backgroundColor: "#F3F4F6",
    textColor: "#4B5563",
    fontSize: "14px",
    fontWeight: 500,
    borderRadius: "4px"
  },
  theme: "light"
};
function gt({
  clientSecret: e,
  type: r,
  commonStyle: t = yt,
  return_url: o,
  isTestnet: n = !1,
  intentType: i,
  ...p
}) {
  if (!e)
    throw console.error("Client secret is required."), new Error("Client secret is required.");
  if (r !== "stripe" && r !== "paymob")
    throw console.error('Payment type must be either "stripe" or "paymob"'), new Error('Invalid payment type. Must be either "stripe" or "paymob"');
  switch (r) {
    case "stripe":
      return /* @__PURE__ */ K(
        ct,
        {
          clientSecret: e,
          commonStyle: t,
          ...o ? { return_url: o } : {},
          isTestnet: n,
          intentType: i,
          ...p
        }
      );
    case "paymob":
      return /* @__PURE__ */ K(
        lt,
        {
          clientSecret: e,
          commonStyle: t,
          ...o ? { return_url: o } : {},
          isTestnet: n
        }
      );
    default:
      return /* @__PURE__ */ Oe("div", { className: dt.error, children: [
        "Unsupported payment type: ",
        r
      ] });
  }
}
export {
  gt as DroplinkedPaymentIntent,
  vt as defaultButtonStyle,
  yt as defaultCommonStyle
};
